import { render } from "./OrganVlastiCard.vue?vue&type=template&id=7a5928f8&scoped=true"
import script from "./OrganVlastiCard.vue?vue&type=script&lang=js"
export * from "./OrganVlastiCard.vue?vue&type=script&lang=js"

import "./OrganVlastiCard.vue?vue&type=style&index=0&id=7a5928f8&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5928f8"]])

export default __exports__